import '@104ha/base-ui/src/style/index.css';
import '@104ha/base-ui/src/init';
import { BrowserRouter } from 'react-router-dom';
import { basename, endpoint } from './constant/endpoint';

import { AuthProvider } from './hook/use-auth';
import { OptionsProvider } from './hook/use-options';
import { BaseProvider } from './provider';
import { RenderRoutes } from './router';
import { GlobalStyle } from './style';

function App() {
	return (
		<AuthProvider>
			{(auData) => (
				<BaseProvider
					endpoint={endpoint}
					headers={{
						Authorization: `Bearer ${auData?.accessToken}`,
					}}
				>
					<GlobalStyle />
					<OptionsProvider>
						<BrowserRouter basename={basename || '/'}>
							<RenderRoutes />
						</BrowserRouter>
					</OptionsProvider>
				</BaseProvider>
			)}
		</AuthProvider>
	);
}

export default App;
